import get from 'lodash/get';
import { numberUnmask } from '../../utils/masks';

const loanDetailsSchema = {
  loanAmount: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  annualGrossIncome: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  monthlyRent: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  employmentStatus: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  employerName: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired'
        || employmentStatus === 'unemployed'
        || employmentStatus === 'student'
      ) {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }

      return true;
    },
  }],
  employerPhone: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }

      const phoneNumbers = [
        '(111) 111-1111',
        '(222) 222-2222',
        '(333) 333-3333',
        '(444) 444-4444',
        '(555) 555-5555',
        '(666) 666-6666',
        '(777) 777-7777',
        '(999) 999-9999',
      ];

      return (
        numberUnmask(input).length < 10
        || phoneNumbers.indexOf(input || '') !== -1
        || (input && input.charAt(1) === '0')
        || (input && input.charAt(1) === '1')
        || (input && input.substring(6) === '000-0000')
      ) ? 'Phone number is not valid' : true;
    },
  }],
  employmentYears: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }
    },
  }],
  consentToVerifyIncomeEmployment: [
    'required',
    {
      isValid: (input) => (
        input || 'The custom field is not valid'
      ),
    },
  ],
};

export default loanDetailsSchema;
